import React, {useState} from 'react'
import AddStandardRuleModal from "./add-standard-rule-modal";
import DeleteRuleModal from './delete-rule-modal';
import StandardRuleRows from "./standard-rule-rows";
import { DndContext, KeyboardSensor, MouseSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove } from '@dnd-kit/sortable';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';

export default function StandardRuleTable({ ruleset, rules, handleUpdate, handleCreateRule, handleDeleteRule, handleUpdateRuleOrder }) {
  const [ showModal, setShowModal] = useState(false)
  const [ showDeleteModal, setShowDeleteModal ] = useState(false);
  const [ ruleToDelete, setRuleToDelete ] = useState({
    index: null,
    rule: null
  });

  function handleSaveNewRule(params) {
    handleCreateRule(params, () => {
      setShowModal(false)
    })
  }

  function onAddRuleClick(e) {
    e.preventDefault();
    setShowModal(true);
  }

  function handleCancelNewRule() {
    setShowModal(false)
  }

  function handleShowDeleteModal(index, rule) {
    setShowDeleteModal(true);
    setRuleToDelete({
      index,
      rule
    })
  }


  function handleConfirmDeleteRule() {
    handleDeleteRule(ruleToDelete.index, ruleToDelete.rule, () => {
      setShowDeleteModal(false)
    })
  }

  function handleCancelDeleteRule() {
    setShowDeleteModal(false);
  }

  function handleDragEnd(event) {
    const { active, over } = event;

    // Prevent moving the 0th element or moving any item to index 0
    const oldIndex = rules.findIndex(rule => rule.id === active.id);
    const newIndex = rules.findIndex(rule => rule.id === over.id);
    if (oldIndex === 0 || newIndex === 0) {
      return; // Do nothing, keep the first element locked
    }


    if (active.id !== over.id) {
      const oldIndex = rules.findIndex(rule => rule.id === active.id);
      const newIndex = rules.findIndex(rule => rule.id === over.id);

      handleUpdateRuleOrder(
        arrayMove(rules, oldIndex, newIndex)
      )
    }
  }

  const sensors = useSensors(
    useSensor(MouseSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor),
    useSensor(KeyboardSensor)
  );

  return (
    <>
      <AddStandardRuleModal
        showModal={showModal}
        ruleset={ruleset}
        handleCreateRule={handleSaveNewRule}
        handleCancel={handleCancelNewRule}
      />
      <DeleteRuleModal
        showModal={showDeleteModal}
        handleDeleteRule={handleConfirmDeleteRule}
        handleCancel={handleCancelDeleteRule}
      />

      <DndContext sensors={sensors} onDragEnd={handleDragEnd} modifiers={[restrictToVerticalAxis]}>
        <table className="min-w-full divide-y divide-gray-300 mt-3">
          <thead className="bg-gray-50">
          <tr>
            <th scope="col" className="px-1 py-1.5 text-left text-sm font-semibold text-gray-900"></th>
            <th scope="col" className="px-1 py-1.5 text-left text-sm font-semibold text-gray-900">
              Source
            </th>
            <th scope="col" className="px-1 py-1.5 text-left text-sm font-semibold text-gray-900 w-40">
              Strategy
            </th>
            <th scope="col" className="px-1 py-1.5 text-left text-sm font-semibold text-gray-900 w-52">
              Cost Plus
            </th>
            <th scope="col" className="px-1 py-1.5 text-left text-sm font-semibold text-gray-900 w-52">
              Retail Minus
            </th>
            <th scope="col" className="px-1 py-1.5 text-left text-sm font-semibold text-gray-900"></th>
          </tr>
          </thead>
          <StandardRuleRows
            rules={rules}
            ruleset={ruleset}
            handleUpdate={handleUpdate}
            handleShowDeleteModal={handleShowDeleteModal}
          />
          <tfoot>
          <tr>
            <td className="whitespace-nowrap py-3 text-sm text-gray-500" colSpan={6}>
              <button
                className="rounded bg-white px-1.5 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                onClick={onAddRuleClick}
              >
                Add Rule
              </button>
            </td>
          </tr>
          </tfoot>
        </table>
      </DndContext>
    </>
  )
}
